"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const helpUrls_1 = require("./helpUrls");
/**
 * @deprecated Use isProduction, isPreProduction, or isDevelopment
 */
const isDevOrStaging = () => {
    return process.env.NODE_ENV === 'development' || process.env.STAGING === 'TRUE';
};
/**
 * @deprecated Use constants/helpUrls
 */
exports.defaultConfig = {
    help: {
        url: helpUrls_1.HELP_ARTICLE_URLS.ROOT,
        referral: helpUrls_1.HELP_ARTICLE_URLS.REFERRAL,
        medely_professionals: helpUrls_1.HELP_ARTICLE_URLS.MEDELY_PROFESSIONALS,
        signing_up: helpUrls_1.HELP_ARTICLE_URLS.SIGNING_UP,
        background_check_pending: helpUrls_1.HELP_ARTICLE_URLS.BACKGROUND_CHECK_PENDING,
        cancellationsAndNoShow: helpUrls_1.HELP_ARTICLE_URLS.CANCELLATION_AND_NO_SHOW(false),
        cancellationsAndNoShowAgency: helpUrls_1.HELP_ARTICLE_URLS.CANCELLATION_AND_NO_SHOW(true),
        partnersHelpCenter: helpUrls_1.HELP_ARTICLE_URLS.PARTNERS_HELP_CENTER,
        covid_requirements: helpUrls_1.HELP_ARTICLE_URLS.COVID_REQUIREMENTS,
        communityGuidelines: helpUrls_1.HELP_ARTICLE_URLS.COMMUNITY_GUIDELINES,
        sms: helpUrls_1.HELP_ARTICLE_URLS.SMS,
        privacyPolicy: helpUrls_1.HELP_ARTICLE_URLS.PRIVACY_POLICY,
    },
    root: '',
    staffOnboardingPath: '/onboarding',
    testTypeform: 'p4ayvY',
    userServiceAgreement: 'https://medely.com/facility_terms',
    professionalTermsPathname: 'https://medely.com/professional_terms',
    calendlyAssignmentURL: isDevOrStaging()
        ? 'https://calendly.com/development-phone-screening/development-phone-screening-2'
        : 'https://calendly.com/phone-screening/assignments',
    calendlyURL: isDevOrStaging()
        ? 'https://calendly.com/ryan-1525/30min'
        : 'https://calendly.com/phone-screening/phone-screening',
    timesheetExtensions: ['.jpg', '.png', '.doc', '.docx', '.pdf'],
    adpUrl: 'https://workforcenow.adp.com/workforcenow/login.html',
    paylocityUrl: 'https://access.paylocity.com',
    pdfServerUrl: process.env.REACT_APP_PDF_URL || process.env.EXPO_PUBLIC_PDF_URL || 'http://localhost:7000',
    adminUrl: process.env.REACT_APP_ADMIN_URL || process.env.EXPO_PUBLIC_ADMIN_URL || 'http://localhost:5000',
    facilityUrl: process.env.REACT_APP_FACILITY_URL ||
        process.env.EXPO_PUBLIC_FACILITY_URL ||
        'http://localhost:3500',
    professionalUrl: process.env.REACT_APP_PROFESSIONAL_URL ||
        process.env.EXPO_PUBLIC_PROFESSIONAL_URL ||
        'http://localhost:3501',
    itemUrl: process.env.REACT_APP_ITEM_URL || process.env.EXPO_PUBLIC_ITEM_URL || 'http://localhost:8500',
    landingsUrl: process.env.REACT_APP_LANDINGS_URL ||
        process.env.EXPO_PUBLIC_LANDINGS_URL ||
        'http://localhost:3001',
    stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
        process.env.EXPO_PUBLIC_STRIPE_PUBLISHABLE_KEY ||
        'pk_test_oB4HJTIwN1v8Y7UHXbqOV40q',
    helloSignId: process.env.REACT_APP_HELLO_SIGN_CLIENT_ID ||
        process.env.EXPO_PUBLIC_HELLO_SIGN_CLIENT_ID ||
        '4abf6c4e85259f2bd4393a61d8b29be5',
    firebaseConfig: {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY ||
            process.env.EXPO_PUBLIC_FIREBASE_API_KEY ||
            'AIzaSyDf0mHckHWJZpHAU20_vKQe57Fc-8zAxI4',
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ||
            process.env.EXPO_PUBLIC_FIREBASE_AUTH_DOMAIN ||
            'medely-staging.firebaseapp.com',
    },
    segmentWriteKey: process.env.REACT_APP_SEGMENT_WRITE_KEY ||
        process.env.EXPO_PUBLIC_SEGMENT_WRITE_KEY ||
        'er91D5qG1t3GcWzx4muqK43RosLAY3BK',
    rollbar: {
        postClientItemKey: process.env.REACT_APP_ROLLBAR_CLIENT_KEY ||
            process.env.EXPO_PUBLIC_ROLLBAR_CLIENT_KEY ||
            '03f95914c79f4f4493df219b767e1480',
    },
    accountPausedTypeformId: isDevOrStaging() ? 'k3EYha' : 'NJTgkr',
    signUpKey: process.env.REACT_APP_SIGNUP_KEY || process.env.EXPO_PUBLIC_SIGNUP_KEY || 'zB9NVETcO9!%',
    facilityReferralTypeform: isDevOrStaging()
        ? 'https://medely.typeform.com/to/p4ayvY'
        : 'https://medely.typeform.com/to/YY80I9',
    statsigSdkKey: process.env.REACT_APP_STATSIG_KEY ||
        process.env.EXPO_PUBLIC_STATSIG_KEY ||
        'client-r9VZ6M6DNDfUWqCsTXYEBDSdo4wLgbtIrpnucXJWZ5a',
};
